import { render, staticRenderFns } from "./IntegrationDetails.vue?vue&type=template&id=663ce363&scoped=true&"
import script from "./IntegrationDetails.vue?vue&type=script&lang=ts&"
export * from "./IntegrationDetails.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationDetails.vue?vue&type=style&index=0&id=663ce363&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663ce363",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
